import { gql } from "config/graphql";
import { GQLUserResponse, IWysh, IWyshCategory } from "config/types";
import { RECIPIENT_FIELDS, WYSH_ALLOCATION_FIELDS, WYSH_FIELDS } from "gql/fragments";
import { gqlQuery } from "store/apollo";

interface IWyshItemsResponse {
  data: {
    wyshes: IWysh[];
  };
}

export const fetchWyshItemsQuery = (): Promise<IWyshItemsResponse> => {
  const query = gql`
    ${WYSH_FIELDS}
    query WyshItems {
      wyshes {
        ...WyshFields
      }
    }
  `;

  return gqlQuery<IWyshItemsResponse["data"]>({
    fetchPolicy: "cache-first",
    query,
  });
};

interface IWyshItemResponse {
  data: {
    wysh: IWysh;
  };
}

export const fetchWyshItemQuery = (slug: string): Promise<IWyshItemResponse> => {
  const query = gql`
    ${WYSH_FIELDS}
    query wysh($slug: String!) {
      wysh(slug: $slug) {
        ...WyshFields
      }
    }
  `;

  return gqlQuery<IWyshItemResponse["data"]>({
    fetchPolicy: "cache-first",
    variables: { slug },
    query,
  });
};

interface IWyshCategoriesResponse {
  data: {
    wyshCategories: IWyshCategory[];
  };
}

export const fetchWyshCategoriesQuery = (): Promise<IWyshCategoriesResponse> => {
  const query = gql`
    query WyshCategories {
      wyshCategories {
        id
        name
        prompt
        slug
        color
        order
        description
        listDescription
        wyshes {
          id
          slug
          prompt
          order
          iconSelected6464 {
            formats {
              contentType
              url
            }
          }
          iconUnselected6464 {
            formats {
              contentType
              url
            }
          }
        }
      }
    }
  `;

  return gqlQuery<IWyshCategoriesResponse["data"]>({
    fetchPolicy: "cache-first",
    query,
  });
};

export const fetchWyshAllocationsQuery = (): Promise<GQLUserResponse<"activeConstellations">> => {
  const query = gql`
    ${RECIPIENT_FIELDS}
    ${WYSH_ALLOCATION_FIELDS}
    query WyshAllocations {
      me {
        activeConstellations {
          wyshAllocations {
            ...WyshAllocationFields
            allocationHistories {
              id
              amount
              change
              direction
              createdAt
              updatedAt
              wyshAllocation {
                name
              }
            }
          }
        }
      }
    }
  `;

  return gqlQuery<GQLUserResponse<"activeConstellations">["data"]>({ query });
};

export const fetchWyshAllocationsSummaryQuery = (): Promise<
  GQLUserResponse<"activeConstellations">
> => {
  const query = gql`
    query WyshAllocationsSummary {
      me {
        activeConstellations {
          allocationSummary {
            activeCount
            totalAmount
            percentCovered
          }
        }
      }
    }
  `;

  return gqlQuery<GQLUserResponse<"activeConstellations">["data"]>({ query });
};
